import FinancialReportsStore from "./FinancialReports.Store";
import { RootStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const financialReportsRoute: RouteType = {
  name: "Financial Reports",
  path: "/accounting/reports/financial",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Financial Reports",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./FinancialReports.Header"),
    },
    body: {
      component: () => import("./FinancialReports.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    // Load all necessary data for reports
    await Promise.all(
      [
        (rootStore.invoicesStore as any)?.find({}),
        (rootStore.billsStore as any)?.find({}),
        (rootStore.paymentsStore as any)?.find({}),
        (rootStore.jobStore as any)?.find({}),
        (rootStore.costAllocationsStore as any)?.find({}),
        (rootStore.productionCostsStore as any)?.find({}),
        (rootStore.laborEntriesStore as any)?.find({}),
        (rootStore.equipmentCostsStore as any)?.find({}),
      ].filter(Boolean)
    );
    return true;
  },
};

export default financialReportsRoute;
